import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  FETCH_CRQ_LIST_ERROR,
  FETCH_CRQ_LIST_REQUEST,
  FETCH_CRQ_LIST_SUCCESS,
  CLEAR_CRQ_LIST,
  CLEAR_CRQ_LIST_ERROR,
  // notification comms
  FETCH_NOTIFICATION_COMMS_REQUEST,
  FETCH_NOTIFICATION_COMMS_SUCCESS,
  FETCH_NOTIFICATION_COMMS_ERROR,
  // detailed comms notification
  FETCH_NOTIFICATION_COMMS__DETAILED_REQUEST,
  FETCH_NOTIFICATION_COMMS_DETAILED_SUCCESS,
  FETCH_NOTIFICATION_COMMS_DETAILED_ERROR,
  // add approver call
  // FL_ADD_APPROVER_CRQ_REQUEST,
  // FL_ADD_APPROVER_CRQ_SUCCESS,
  // FL_ADD_APPROVER_CRQ_ERROR,
} from './crq-list-actions';

const crqListReducerDefaultState = {
  isFetching: false,
  crqList: [],
  approvalList: [],
  hasError: false,
  notificationCommsList: [],
  notificationCommsListDetailed: [],
  isEmpty: true,
  isEmptyComms: true,
};

const fetchCrqListRequest = (state, action) => ({
  ...state,
  isFetching: true,
  hasError: false,
});

const fetchCrqListSuccess = (state, action) => ({
  ...state,
  crqList: action.payload.results,
  isFetching: false,
  hasError: false,
});

const fetchCrqListError = (state, action) => ({
  ...state,
  isFetching: false,
  hasError: true,
});

// const flAddApproverGroupsToCrqRequest = (state, action) => ({
//   ...state,
//   isFetching: true,
//   hasError: false,
// });

// const flAddApproverGroupsToCrqSuccess = (state, action) => ({
//   ...state,
//   approvalList: action.payload.results,
//   isFetching: false,
//   hasError: false,
// });

// const flAddApproverGroupsToCrqError = (state, action) => ({
//   ...state,
//   isFetching: false,
//   hasError: true,
// });

const clearCrqList = (state, action) => ({
  ...state,
  crqList: [],
});

const clearError = (state, action) => ({
  ...state,
  hasError: false,
});

// comms notification
const fetchNotificationCommsRequest = (state, action) => ({
  ...state,
  isFetching: true,
  hasError: false,
  isEmptyComms: true,
});

const fetchNotificationCommsSuccess = (state, action) => ({
  ...state,
  notificationCommsList: action.payload.results,
  isFetching: false,
  hasError: false,
  isEmptyComms: false,
});

const fetchNotificationCommsError = (state, action) => ({
  ...state,
  isFetching: false,
  hasError: true,
  isEmptyComms: true,

});

// comms notification Detailed
const fetchNotificationCommsDetailedRequest = (state, action) => ({
  ...state,
  isFetching: true,
  isEmpty: true,
  hasError: false,
});

const fetchNotificationCommsDetailedSuccess = (state, action) => ({
  ...state,
  notificationCommsListDetailed: action.payload.results,
  isFetching: false,
  isEmpty: false,
  hasError: false,
});

const fetchNotificationCommsDetailedError = (state, action) => ({
  ...state,
  isFetching: false,
  isEmpty: true,
  hasError: true,
});

// Action handlers dictionary
// defines the mapping between actions and the handler methods
const actionHandlers = {
  [FETCH_CRQ_LIST_REQUEST]: fetchCrqListRequest,
  [FETCH_CRQ_LIST_SUCCESS]: fetchCrqListSuccess,
  [FETCH_CRQ_LIST_ERROR]: fetchCrqListError,
  [CLEAR_CRQ_LIST]: clearCrqList,
  [CLEAR_CRQ_LIST_ERROR]: clearError,
  // comms notification
  [FETCH_NOTIFICATION_COMMS_REQUEST]: fetchNotificationCommsRequest,
  [FETCH_NOTIFICATION_COMMS_SUCCESS]: fetchNotificationCommsSuccess,
  [FETCH_NOTIFICATION_COMMS_ERROR]: fetchNotificationCommsError,
  // comms notification Detailed
  [FETCH_NOTIFICATION_COMMS__DETAILED_REQUEST]: fetchNotificationCommsDetailedRequest,
  [FETCH_NOTIFICATION_COMMS_DETAILED_SUCCESS]: fetchNotificationCommsDetailedSuccess,
  [FETCH_NOTIFICATION_COMMS_DETAILED_ERROR]: fetchNotificationCommsDetailedError,
  // add approver call
  // not needed as of now.
  // [FL_ADD_APPROVER_CRQ_REQUEST]: flAddApproverGroupsToCrqRequest,
  // [FL_ADD_APPROVER_CRQ_SUCCESS]: flAddApproverGroupsToCrqSuccess,
  // [FL_ADD_APPROVER_CRQ_ERROR]: flAddApproverGroupsToCrqError,
};

// create the reducer
const crqListReducer = createReducer(crqListReducerDefaultState, actionHandlers);

export {
  crqListReducerDefaultState,
  crqListReducer,
};
